module.exports = __webpack_public_path__ + "static/flags/NE-a876dbbf7078bec2c64d3414bd40f678.gif";